import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'
import getExtendDuration from 'utils/pivot/plan/getExtendDuration'
import getPeriodId from 'utils/pivot/plan/getPeriodId'
import getValidDuration from 'utils/pivot/plan/getValidDuration'
import getValidPeriodKey from 'utils/pivot/plan/period/getValidPeriodKey'
import parsePlanPeriod from 'utils/pivot/plan/period/parsePlanPeriod'
import store from 'utils/store/withMiddleware'

function getPeriodOptions({ plan, filterOptions, filters }) {
  // duration
  const { hcStorage, defaultPeriod } = store.getState()

  const period = String(filters.period || defaultPeriod)

  const periodOpts = filterOptions.period.values.reduce((result, current) => {
    const { period, policies } = parsePlanPeriod(current)

    const extendedDuration = getExtendDuration(plan, period)

    const customLabel = getPeriodId(policies, period, {
      stateAcronym: hcStorage.location.state_acronym,
      plan,
      omitSinglePolicy: true,
      extendedDuration: extendedDuration || period
    })
    result[current] = `${customLabel} days`
    return result
  }, {})

  const validatedPlanDurations = getAndValidatePeriod(plan, period)

  const duration: Duration = getValidDuration(validatedPlanDurations, filters.policies)
  const validatedPlanPeriod = duration.policyDuration
  const planPolicies = duration.recurrence

  const planPeriodValue = parsePlanPeriod(String(validatedPlanPeriod))

  const validatedPeriodKey = getValidPeriodKey(plan, planPeriodValue.period)

  const values = period.includes(validatedPeriodKey) ? period : validatedPeriodKey

  let keyValue = `${planPolicies > 1 ? `${planPolicies}x` : ''}${values}`

  if (
    hcStorage.location.state_acronym === 'ND' &&
    planPolicies > 1 &&
    plan.planTypeKey.includes('epic')
  ) {
    keyValue = '360'
  }

  return { options: periodOpts, values: [keyValue] }
}

export default getPeriodOptions
